import { render } from "./admin.vue?vue&type=template&id=29b0ee3a&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=29b0ee3a&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b0ee3a"]])

export default __exports__